export default class AppConfig {

    constructor() {
    }

    saveTimeout() {
        switch (window.environment) {
            case 'development':
                return 2000;
            case 'production':
                return 2000;
            case 'test':
                return 50;
        }
    }

    queryTimeout() {
        switch (window.environment) {
            case 'development':
                return 400;
            case 'production':
                return 400;
            case 'test':
                return 250;
        }
    }
}


declare global {
    interface Window {
        AppConfig: AppConfig;
        environment: string;
        Turbo: any;
    }
}

window.AppConfig = new AppConfig();
